import { Heading, Ellipsis } from '@zoom/components';
import classnames from 'classnames';
import React from 'react';

type ActionBarType = React.ReactNode;

export interface HeaderProps {
  actionBar?: ActionBarType;
  icon?: React.ReactNode;
  subtitle?: React.ReactNode;
  testId?: string;
  title: string;
  titleSlug: string;
}

interface CommonHeaderProps extends HeaderProps {
  forwardedRef?: React.RefObject<HTMLDivElement>;
}

export const composeTestId = (title: string, element: string) => `${title.toLocaleLowerCase()}:${element}`;

export const ActionBarWrapper = (elements: ActionBarType, title: string) => (
  <div className="header__action-bar-wrapper" data-test-id={composeTestId(title, 'action-bar:wrapper')}>
    {elements}
  </div>
);

export const CommonHeader: React.FC<CommonHeaderProps> = ({
  actionBar,
  forwardedRef,
  icon,
  testId,
  title,
  titleSlug,
  subtitle,
}) => (
  <div className={classnames('header')} ref={forwardedRef}>
    <div className="header__title-wrapper">
      <Heading data-test-id={testId || composeTestId(titleSlug, 'title')} kind="page">
        {title}
        {subtitle && `:`}
      </Heading>
      {icon && <div className="header__icon">{icon}</div>}
      {subtitle && (
        <div className="header__subtitle">
          {/* @ts-expect-error: Incompatible type of FC from React < v18 */}
          <Ellipsis>{subtitle}</Ellipsis>
        </div>
      )}
    </div>
    {actionBar && ActionBarWrapper(actionBar, titleSlug)}
  </div>
);
